import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import Clover from '@img/icons/clover-green-list.svg';
import HHSvg from '@img/icons/HH-icon-list.svg';
import Leaf from '@img/icons/leafList.svg';
import RssSvg from '@img/icons/petal-bullet.svg';
import styled, { css } from 'styled-components';
import ParagraphStyles from './Paragraph.styles';
import brand from '@helpers/brand';
const LiStyles = css `
  ${fonts.sourceSansPro.regular}
  ${ParagraphStyles.RegularStyles}
  padding-left: 26px;
  margin-bottom: 8px;
  position: relative;
  color: ${brand.grey};

  @media ${until(Device.Tablet)} {
    font-size: 18px;
    line-height: 28px;
  }

  .theme-apl &,
  .theme-hh &,
  .theme-rss & {
    padding-left: 30px;
    color: ${brand.black};
  }

  &:before {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    background-color: ${brand.htaRebrand.green};
    position: absolute;
    border-radius: 50%;
    left: 0;
    top: 12px;

    @media ${until(Device.Tablet)} {
      width: 8px;
      height: 8px;
    }

    .theme-apl &,
    .theme-hh &,
    .theme-rss & {
      content: '';
      display: block;
      width: 16px;
      height: 16px;
      background-image: url(${Clover});
      background-color: transparent;
      border-radius: 0;
      background-repeat: no-repeat;
      position: absolute;
      left: 0;
      top: 10px;
    }

    .theme-apl & {
      top: 10px;
      background-image: url(${Leaf});
    }

    .theme-hh & {
      top: 10px;
      background-image: url(${HHSvg});
    }

    .theme-rss & {
      top: 10px;
      background-image: url(${RssSvg});

      @media ${until(Device.Tablet)} {
        top: 6px;
      }
    }
  }

  .theme-rss & {
    font-size: 20px;
    margin-bottom: 15px;

    @media ${until(Device.Tablet)} {
      font-size: 16px;
      line-height: 26px;
    }
  }
`;
const UnorderedList = styled.ul `
  padding-left: 0;
  list-style: none;
  margin-left: 0;


  li {
    ${LiStyles}
  }
`;
export default {
    UnorderedList,
    LiStyles,
};
